import React from "react";
import PropTypes from "prop-types";
import Button from "../elements/button";
import Icon from "../elements/icon";
/**
 * A basic modal header with a title and an optional cancel button
 * that will only be displayed if a closeModal function is provided.
 * If a custom header is needed in the future, consider creating a seperate component.
 */

var ModalHeader = function ModalHeader(_ref) {
  var title = _ref.title,
      closeModal = _ref.closeModal;
  return /*#__PURE__*/React.createElement("div", {
    className: "et--modal-header"
  }, /*#__PURE__*/React.createElement("h3", null, title), closeModal && /*#__PURE__*/React.createElement(Button, {
    type: "simple",
    onClick: closeModal
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "et--modal-confirm--close",
    icon: "close"
  })));
};

ModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  closeModal: PropTypes.func
};
export default ModalHeader;